var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58986 15.5334C6.79717 16.9064 5.04155 17.3768 3.66856 16.5841C2.29558 15.7914 1.82517 14.0358 2.61786 12.6628L7.58986 15.5334Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.626 18.8238L1.99778 12.1103C1.2832 11.6977 1.2839 10.8978 1.75011 10.2571C1.85777 10.1091 2.00662 9.99809 2.16396 9.90465L3.66113 9.01554C4.60759 8.45348 5.42787 7.70214 6.07065 6.80854L7.36741 5.00577C7.51892 4.79515 7.67864 4.5922 7.86637 4.41309C8.55124 3.75969 10.4657 2.19548 12.8542 2.47495L13.064 2.11154C13.6519 1.09333 14.954 0.744566 15.9724 1.33255C16.9909 1.92054 17.3399 3.22262 16.752 4.24083L16.5422 4.60424C17.9458 6.48916 17.5982 8.8625 17.3731 9.82789C17.3042 10.1233 17.1892 10.4039 17.06 10.6783L16.2118 12.4797C15.7099 13.5456 15.4496 14.7093 15.4496 15.8875L15.4496 17.5645C15.4496 17.7558 15.4284 17.9489 15.3496 18.1232C15.0256 18.8401 14.3368 19.2342 13.626 18.8238Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.bc290a177ccbd3673478933d840cf8ee.svg";
export { ForwardRef as ReactComponent };